import * as Sentry from '@sentry/react';

let initialized = false;

export function initSentry() {
  if (initialized) return;
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  try {
    Sentry.init({
      dsn,
      environment: process.env.NODE_ENV || 'development',
      release: process.env.REACT_APP_GIT_SHA || undefined,
      tracesSampleRate: 0.05,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0.1,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
      ],
      beforeSend(event) {
        if (event.user) {
          delete event.user.email;
          delete event.user.ip_address;
        }
        return event;
      },
    });
    initialized = true;
  } catch (err) {
    console.warn('Sentry init failed; continuing without observability:', err);
  }
}

export function identifySentry({ id, userType }) {
  if (!initialized) return;
  try {
    Sentry.setUser({ id, segment: userType });
  } catch { /* noop */ }
}

export function captureException(err, context) {
  if (!initialized) {
    console.error(err, context);
    return;
  }
  try { Sentry.captureException(err, { extra: context }); } catch { /* noop */ }
}

export const ErrorBoundary = Sentry.ErrorBoundary;
